/** Where an owner reaches a person when the product cannot fix it for them. */
export const SUPPORT_EMAIL = 'support@topcall24.com';

/** Open the owner's mail client addressed to support. */
export function mailSupport(subject: string): void {
  window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
